import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useCopyToClipboard } from 'react-use'

import { TtButton, TtButtonGroup, TtIcon, TtTextField } from '@23/ui-react'

import { showNotice } from '../../../Layout/Notices/Notices'

import './ConnectionDetailField.scss'

interface ConnectionDetailFieldProps {
  label: React.ReactNode
  value?: string
  copyLabel: string
}

export const ConnectionDetailField = ({
  label,
  value,
  copyLabel,
}: ConnectionDetailFieldProps) => {
  const [, copyToClipboard] = useCopyToClipboard()
  const intl = useIntl()

  const handleCopy = useCallback(() => {
    if (!value) return

    copyToClipboard(value)
    showNotice({
      expirationMillis: 2000,
      isClosable: true,
      message: intl.formatMessage({ defaultMessage: 'Copied to clipboard' }),
    })
  }, [copyToClipboard, value, intl])

  if (!value) return null

  return (
    <div className="connection-detail-field">
      <label>{label}</label>
      <TtButtonGroup className="connection-detail-field-button-group">
        <TtTextField
          name={`connection-detail-${copyLabel.toLowerCase().replace(/\s+/g, '-')}`}
          label=""
          hideLabel
          value={value}
          className="connection-detail-field-input"
        />
        <TtButton
          size="medium"
          circle
          variant="light"
          color="secondary"
          label={copyLabel}
          onClick={handleCopy}
          className="connection-detail-field-button"
        >
          <TtIcon name="duplicate" library="one" />
        </TtButton>
      </TtButtonGroup>
    </div>
  )
}
